import {
  agressorsInfos,
  datestepSeven,
  instruction,
  loadingSaveComplaint,
  selectedStatusStepFive,
  sendTo,
  setRecordValid,
  stepReasonValue,
  textAreaStepFive,
  textAreaStepSeven,
} from "@core/slice/ComplaintSlice.ts";
import { useAppDispatch, useAppSelector } from "@core/store/hook.ts";
import { Button } from "primereact/button";
import { ConfirmDialog } from "primereact/confirmdialog";
import { Dialog } from "primereact/dialog";
import React, { useRef, useState } from "react";
import jsPDF from "jspdf";
import { formatLongDate, getHour } from "@utils/appUtils.ts";
import { ageGroup } from "@modules/plaintes/plaintes.model.ts";
import { dataUser, profilLookup } from "@core/slice/UsersSlice.ts";
import { saveComplaint } from "@core/actions/complaintAction.ts";
import { useNavigate } from "react-router-dom";
import { classNames } from "primereact/utils";
import { FetchStatusType } from "@core/modeles/model.ts";
import { AxiosError } from "axios";

interface ReadingAloudProps {
  isReadingAloud: boolean;
  setIsReadingAloud: (a: boolean) => void;
  isSignature?: boolean;
  setOpen: (a: any) => void;
  setMessageInfo: (a: any) => void;
}

const ReadingAloud = (props: ReadingAloudProps) => {
  const intervalRef = useRef<NodeJS.Timeout | null>(null);
  const {
    isReadingAloud,
    setIsReadingAloud,
    isSignature,
    setMessageInfo,
    setOpen,
  } = props;
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const aggressors = useAppSelector(agressorsInfos);
  const stepReason = useAppSelector(stepReasonValue);
  const textAreaValue = useAppSelector(textAreaStepFive);
  const selectedStatus = useAppSelector(selectedStatusStepFive);
  const userInfos = useAppSelector(dataUser);
  const loading = useAppSelector(loadingSaveComplaint);

  const actionStepSeven = useAppSelector(textAreaStepSeven);
  const selectedInstruction = useAppSelector(instruction);
  const selectedSendTo = useAppSelector(sendTo);
  const dateSeven = useAppSelector(datestepSeven);
  const listsProfil = useAppSelector(profilLookup);

  const [Record, setRecord] = useState<
    "DEMARRE" | "IN_PROGRESS" | "FINISHED" | "VALID"
  >("DEMARRE");
  const [timer, setTimer] = useState<number>(0);
  const [readValid, setReadValid] = useState<boolean>(false);
  const [dialogObect, setDialogObject] = useState<{
    open: boolean;
    message: string;
    code: number | null;
  }>({ open: false, message: "", code: null });

  const mocipProfil = listsProfil.find((i) => i.name.toLocaleLowerCase().trim() === "point focal mocip");

  const transformName = (fullName: string) => {
    return fullName.trim().split(/\s+/);
  };

  const showSuccessMessage = () => {
    setMessageInfo({
      severity: "success",
      summary: "Succès",
      detail: "Enregistrement plainte réussi!",
    });
    setOpen(true);
  };

  const showErrorMessage = (error: AxiosError) => {
    
    const errorData = error.response?.data as { message?: string } | undefined;
    setMessageInfo({
      severity: "error",
      summary: "Erreur",
      detail: errorData?.message ?? "Une erreur est survenue",
    });
    
    setOpen(true);
  };

  const displayIfValueText = (
    label: string,
    value?: string | number | null
  ): string | null => {
    return value && value !== "" ? `${label}${value}` : null;
  };
  const displayIfValueJSX = (
    label: string,
    value: string | undefined | null
  ) => {
    if (!value) return null;
    return (
      <p className="my-1">
        <strong>{label}</strong>
        {value}
      </p>
    );
  };

  const blocConstruct = (lines: (string | null | undefined)[]) => {
    return lines.filter(Boolean).join("\n");
  };

  const findAgeGroup = (age: string) => {
    const findAge = ageGroup.find((a) => a.code === age);
    return findAge?.name;
  };

  const nom = stepReason?.stepTwo?.fullName;
  const handicape = stepReason?.stepTwo?.disabled === true ? "Oui" : "Non";
  const number = stepReason?.stepTwo?.phoneNumber ?? "";
  const cinNumber = stepReason?.stepTwo?.cinNumber ?? "";
  const address = stepReason?.stepTwo?.address ?? "";

  const plaignantText = stepReason?.stepTwo?.anonym
    ? "Plaignant anonyme"
    : blocConstruct([
        displayIfValueText("Nom du plaignant : ", nom),
        displayIfValueText("Personne handicapée : ", handicape),
        displayIfValueText("Numéro de téléphone : ", number),
        displayIfValueText(
          "Numéro de Carte Nationnal d'identité : ",
          cinNumber
        ),
        displayIfValueText("Adresse : ", address),
      ]);
  const plaignantJSX = stepReason?.stepTwo?.anonym ? (
    displayIfValueJSX("", "Plaignant anonyme")
  ) : (
    <>
      {displayIfValueJSX("Nom du plaignant : ", nom)}
      {displayIfValueJSX("Personne handicapée : ", handicape)}
      {displayIfValueJSX("Numéro de téléphone : ", number)}
      {displayIfValueJSX("Numéro de Carte Nationnal d'identité : ", cinNumber)}
      {displayIfValueJSX("Adresse : ", address)}
    </>
  );
  const object = stepReason?.stepThree?.object?.name;
  const date = formatLongDate(stepReason?.stepThree?.incidentDate);
  const hour =
    stepReason?.stepThree?.incidentHour === ""
      ? ""
      : getHour(stepReason?.stepThree?.incidentHour);
  const lieu =
    stepReason?.stepThree?.location.name === "Autres"
      ? stepReason?.stepThree?.otherLocation
      : stepReason?.stepThree?.location.name;

  const region = stepReason?.stepThree?.region?.name;
  const district = stepReason?.stepThree?.district?.name;
  const commune = stepReason?.stepThree?.commune?.name;
  const fokontany = stepReason?.stepThree?.fokotany?.name;
  const description = stepReason?.stepThree?.description!;

  const motif = stepReason?.stepFour.natureComplaintSelectedList
    ?.map((nature) => {
      const subNatureSelected =
        stepReason.stepFour.subNatureComplaintSelectedList
          .filter((sub) => sub.natureId === nature.id)
          .map((sub) => {
            const info = stepReason.stepFour.complaintSubNatures
              .find(
                (csn) =>
                  csn.natureId === nature.id && csn.subnatureId === sub.id
              )
              ?.additionalInfo?.trim();
            if (nature.id === 16) return info ? `${info}` : null;
            return info ? `${sub.description} : ${info}` : sub.description;
          })
          .filter(Boolean);
      if (!subNatureSelected || subNatureSelected.length === 0) {
        return null;
      }
      return `\nNature : ${
        nature.name
      } \nSous-natures : ${subNatureSelected.join(" | ")}`;
    })
    .filter(Boolean)
    .join("\n");

  const contenuText = blocConstruct([
    plaignantText,
    displayIfValueText("Objet de la plainte : ", object),
    displayIfValueText("Date de l'incident : ", date),
    displayIfValueText("Heure de l'incident : ", hour),
    displayIfValueText("Lieu de l'incident : ", lieu),
    displayIfValueText("Region : ", region),
    displayIfValueText("District : ", district),
    displayIfValueText("Commune : ", commune),
    displayIfValueText("Fokontany : ", fokontany),
    displayIfValueText("Description du cas : ", description),
    displayIfValueText("MOTIF DE LA PLAINTE ", motif),
    displayIfValueText(
      "Statut de la plainte : ",
      isSignature ? "" : selectedStatus?.name
    ),
    displayIfValueText(
      "Action entreprise : ",
      isSignature ? "" : textAreaValue
    ),
  ]);
  const contenuJSX = (
    <>
      {displayIfValueJSX("Objet de la plainte : ", object)}
      {displayIfValueJSX("Date de l'incident : ", date)}
      {displayIfValueJSX("Heure de l'incident : ", hour)}
      {displayIfValueJSX("Lieu de l'incident : ", lieu)}
      {displayIfValueJSX("Region : ", region)}
      {displayIfValueJSX("District: ", district)}
      {displayIfValueJSX("Commune : ", commune)}
      {displayIfValueJSX("Fokontany : ", fokontany)}
      {displayIfValueJSX("Description du cas : ", description)}
      {displayIfValueJSX("MOTIF DE LA PLAINTE ", motif)}
      {displayIfValueJSX(
        "Statut de la plainte : ",
        isSignature ? "" : selectedStatus?.name
      )}
      {displayIfValueJSX(
        "Action entreprise : ",
        isSignature ? "" : textAreaValue
      )}
    </>
  );
  const victimName = `${stepReason?.victimStep?.lastName} ${stepReason?.victimStep?.firstName}`;
  const gender = stepReason?.victimStep?.gender === "MALE" ? "Homme" : "Femme";
  const age = findAgeGroup(stepReason?.victimStep?.ageGroup!);
  const cin = stepReason?.victimStep?.cin;
  const victimHandicap =
    stepReason?.victimStep?.disability === true ? "Oui" : "Non";
  const handicapType = stepReason?.victimStep?.disabilityInfo;
  const student = stepReason?.victimStep?.student;
  const employee = stepReason?.victimStep?.employee;
  const father = stepReason?.victimStep?.fatherName;
  const mother = stepReason?.victimStep?.motherName;
  const matrimonialStatus = stepReason?.victimStep?.martialStatus?.name;
  const cohabitation =
    stepReason?.victimStep?.parentCohabitation === true ? "Oui" : "Non";
  const phoneNumber = stepReason?.victimStep?.contactNumber;
  const addressVictim = stepReason?.victimStep?.contactAddress;

  const contentSignatureText = blocConstruct([
    "INFORMATION SUR LA VICTIME",
    "",
    ...[
      displayIfValueText("Nom de la victime : ", victimName),
      displayIfValueText("Sexe : ", gender),
      displayIfValueText("Age : ", age),
      displayIfValueText("CNI : ", cin),
      displayIfValueText("Handicapé(e) : ", victimHandicap),
      stepReason?.victimStep?.disability
        ? displayIfValueText("Remarque spéciale : ", handicapType.name)
        : null,
      displayIfValueText("Etudiant(e) : ", student),
      displayIfValueText("Employé(e) : ", employee),
      displayIfValueText("Père : ", father),
      displayIfValueText("Mère : ", mother),
      displayIfValueText("Situation matrimoniale : ", matrimonialStatus),
      displayIfValueText("Cohabitation : ", cohabitation),
      displayIfValueText("Numéro de téléphone : ", phoneNumber),
      displayIfValueText("Adresse : ", addressVictim),
    ].filter(Boolean),
    "",
    "INFORMATION SUR L'AGRESSEUR",
    "",
    ...aggressors
      .filter((a) => a && typeof a === "object")
      .map((a, index) =>
        blocConstruct([
          `Agresseur ${index + 1} :`,
          displayIfValueText(
            "Nom : ",
            a.lastName !== "" ? `${a.lastName} ${a.firstName}` : ""
          ),
          displayIfValueText("Sexe : ", a.sex === "MALE" ? "Homme" : "Femme"),
          displayIfValueText("Âge : ", findAgeGroup(a.age as string)),
          displayIfValueText("Nationalité : ", a.nationality ?? "Malagasy"),
          displayIfValueText("Lien avec la victime : ", a.relation?.name),
          displayIfValueText("Adresse : ", a.adresse),
          "",
        ])
      ),
    ...selectedInstruction
      .filter((a) => a && typeof a === "object")
      .map((a) =>
        blocConstruct([
          displayIfValueText(
            "Instruction et prise en charge : ",
            `${a?.description ?? ""} `
          ),
        ])
      ),
    blocConstruct([
      displayIfValueText("Date : ", `${dateSeven === null ? "" : dateSeven}`),
      displayIfValueText(
        "Envoyer vers  : ",
        `${selectedSendTo?.description ?? ""} `
      ),
      displayIfValueText("Action entreprise  : ", `${actionStepSeven} `),
    ]),
  ]);
  const contentSignatureJSX = (
    <>
      <br />
      <p className="mb-2">INFORMATION SUR LA VICTIME</p>
      {displayIfValueJSX("Nom de la victime : ", victimName)}
      {displayIfValueJSX("Sexe : ", gender)}
      {displayIfValueJSX("Age : ", age)}
      {displayIfValueJSX("CNI : ", cin)}
      {displayIfValueJSX("Handicapé(e) : ", victimHandicap)}
      {stepReason?.victimStep?.disability
        ? displayIfValueJSX("Remarque spéciale : ", handicapType.name)
        : null}
      {displayIfValueJSX("Etudiant(e) : ", student)}
      {displayIfValueJSX("Employé(e) : ", employee)}
      {displayIfValueJSX("Père : ", father)}
      {displayIfValueJSX("Mère : ", mother)}
      {displayIfValueJSX("Situation matrimoniale : ", matrimonialStatus)}
      {displayIfValueJSX("Cohabitation : ", cohabitation)}
      {displayIfValueJSX("Numéro de téléphone : ", phoneNumber)}
      {displayIfValueJSX("Adresse : ", addressVictim)}
      <br />
      <p className="mt-2">INFORMATION SUR L'AGRESSEUR</p>
      <br />
      {aggressors
        .filter((a) => a && typeof a === "object")
        .map((a, index) => (
          <React.Fragment key={`agresseur-${index}`}>
            <p
              key={`agresseur-title-${index}${a}`}
              className="font-semibold mt-2"
            >
              Agresseur {index + 1} :
            </p>
            {displayIfValueJSX(
              "Nom : ",
              a.lastName !== "" ? `${a.lastName} ${a.firstName}` : ""
            )}
            {displayIfValueJSX("Sexe : ", a.sex === "MALE" ? "Homme" : "Femme")}
            {displayIfValueJSX("Âge : ", findAgeGroup(a.age as string))}
            {displayIfValueJSX("Nationalité : ", a.nationality ?? "Malagasy")}
            {displayIfValueJSX("Lien avec la victime : ", a.relation?.name)}
            {displayIfValueJSX("Adresse : ", a.adresse)}
          </React.Fragment>
        ))}
      <br />
      {displayIfValueJSX(
        "Instruction et prise en charge : ",
        selectedInstruction
          .filter((a) => a && typeof a === "object")
          .map((a) => a?.description?.trim())
          .filter(Boolean)
          .join(", ")
      )}
      {displayIfValueJSX("Date : ", `${dateSeven === null ? "" : formatLongDate(dateSeven)}`)}
      {displayIfValueJSX(
        "Envoyer vers  : ",
        `${selectedSendTo?.description ?? ""} `
      )}
      {displayIfValueJSX("Action entreprise  : ", `${actionStepSeven} `)}
    </>
  );

  const handleExportPDF = async () => {
    const pdf = new jsPDF({
      orientation: "portrait",
      unit: "mm",
      format: "a4",
    });
    const marginLeft = 20;
    const marginTop = 70;
    const marginBottom = 20;
    const pageHeight = pdf.internal.pageSize.getHeight();
    const lineHeight = 10;
    const date = new Date();
    const formattedDate = date.toLocaleDateString("fr-FR");
    let currentY = marginTop;
    const lines = pdf.splitTextToSize(
      isSignature ? contenuText + "\n" + contentSignatureText : contenuText,
      170
    );
    const boldLabels = [
      "Objet de la plainte : ",
      "Date de l'incident : ",
      "Heure de l'incident : ",
      "Lieu de l'incident : ",
      "Region : ",
      "District : ",
      "Commune : ",
      "Fokontany : ",
      "Description du cas : ",
      "Statut de la plainte : ",
      "Action entreprise : ",
      "Nom de la victime : ",
      "Sexe : ",
      "Age : ",
      "CNI : ",
      "Handicapé(e) : ",
      "Remarque spéciale : ",
      "Etudiant(e) : ",
      "Employé(e) : ",
      "Père : ",
      "Mère : ",
      "Situation matrimoniale : ",
      "Cohabitation : ",
      "Numéro de téléphone : ",
      "Adresse : ",
      "Nom : ",
      "Sexe : ",
      "Âge : ",
      "Nationalité : ",
      "Lien avec la victime : ",
      "Adresse : ",
      "Instruction et prise en charge : ",
      "Date : ",
      "Envoyer vers  : ",
      "Action entreprise  : ",
      "Numéro de Carte Nationnal d'identité : ",
      "Personne handicapée : ",
      "Nom du plaignant : ",
      "Nature : ",
      "Sous-natures : ",
    ];
    const imageData = "/assets/LOGO_MPS.png";
    pdf.addImage(imageData, "PNG", 140, 10, 60, 40);
    pdf.setFont("Helvetica", "bold");
    pdf.setFontSize(14);
    pdf.text("Ministère de la Population et des Solidarités", 20, 20);
    pdf.setFont("Helvetica", "normal");
    pdf.setFontSize(14);
    pdf.text(`Aujourd'hui, ${formattedDate} `, 20, 30);
    pdf.text("Résumé de la plainte", 20, 40);
    pdf.setFont("Helvetica", "normal");
    pdf.setFontSize(12);
    lines.forEach((line: string) => {
      if (currentY + lineHeight > pageHeight - marginBottom) {
        pdf.addPage();
        currentY = 30;
      }
      const label = boldLabels.find((lbl) => line.trim().startsWith(lbl));
      if (label) {
        const value = line.replace(label, "").trim();
        pdf.setFont("Helvetica", "bold");
        pdf.text(label, marginLeft, currentY);

        const labelWidth = pdf.getTextWidth(label);
        pdf.setFont("Helvetica", "normal");
        pdf.text(value, marginLeft + labelWidth, currentY);
      } else {
        pdf.setFont("Helvetica", "normal");
        pdf.text(line, marginLeft, currentY);
      }
      currentY += lineHeight;
    });
    pdf.save("resume.pdf");
  };

  const messageConfirm = () => {
    return (
      <div className="flex items-center">
        <i className="pi pi-exclamation-circle text-orange-500 text-4xl mr-3"></i>
        <p>Est-ce que les informations de la plainte sont correctes ?</p>
      </div>
    );
  };

  const RecordAcceptable = (text: string, timerMinute: number) => {
    const words = text.trim().split(/\s+/).length;
    const wordMinut = 200;
    const estimation = words / wordMinut;
    const minMinute = estimation * 0.7;
    return timerMinute >= minMinute;
  };

  const footerContent = () => {
    const handleSaveComplaint = () => {
      const uuid = userInfos?.uuid.value;
      if (isSignature) {
        if (
          stepReason &&
          stepReason.stepOne &&
          stepReason.stepTwo &&
          stepReason.stepThree &&
          stepReason.stepFour &&
          stepReason.victimStep
        ) {
          dispatch(
            saveComplaint({
              filter: {
                aggressors: aggressors.map((a) => {
                  return {
                    address: a.adresse,
                    ageGroup: a.age ?? 0,
                    firstName: a.firstName,
                    gender: a.sex,
                    lastName: a.lastName,
                    nationality: a.nationality ?? "malagasy",
                    victimRelationShip: a.relation?.code ?? "FATHER",
                  };
                }),
                supportTypes: selectedInstruction.map(
                  (supportType) => supportType.id
                ),
                careInstructions: [],
                complaintDetails: [
                  {
                    ageGroup: stepReason.victimStep.ageGroup,
                    cin: stepReason.victimStep.cin,
                    lastName: `${stepReason.victimStep.lastName}`.trim(),
                    firstName: `${stepReason.victimStep.firstName}`.trim(),
                    disability: stepReason.victimStep.disability,
                    householdId: stepReason.victimStep.householdId,
                    individualId: stepReason.victimStep.individualId,
                    parentCohabitation:
                      stepReason.victimStep.parentCohabitation,
                    contactNumber: stepReason.victimStep.contactNumber,
                    contactAddress: stepReason.victimStep.contactAddress,
                    fatherName: stepReason.victimStep.fatherName,
                    motherName: stepReason.victimStep.motherName,
                    student: stepReason.victimStep.student,
                    employee: stepReason.victimStep.employee,
                    disabilityInfo: stepReason.victimStep.disability
                      ? stepReason.victimStep.disabilityInfo.code
                      : null,
                    gender: stepReason.victimStep.gender,
                    martialStatus: stepReason.victimStep.martialStatus ?? null,
                  },
                ],
                complaintInfo: {
                  fullName: stepReason.stepTwo.anonym
                    ? ""
                    : stepReason.stepTwo.fullName,
                  cinNumber: stepReason.stepTwo.anonym
                    ? ""
                    : stepReason.stepTwo.cinNumber,
                  phoneNumber: stepReason.stepTwo.anonym
                    ? ""
                    : stepReason.stepTwo.phoneNumber,
                  householdId: stepReason.stepTwo.householdId,
                  individualId: stepReason.stepTwo.individualId,
                  address: stepReason.stepTwo.anonym
                    ? ""
                    : stepReason.stepTwo.address,
                  relationshipWithVictim:
                    stepReason.stepTwo.anonym ||
                    stepReason.stepTwo.relationshipWithVictim === ""
                      ? null
                      : stepReason.stepTwo.relationshipWithVictim,
                  disabled: stepReason.stepTwo.anonym
                    ? false
                    : stepReason.stepTwo.disabled,
                  anonym: stepReason.stepTwo.anonym,
                  isVictim: stepReason.stepTwo.isVictim,
                },
                description: stepReason.stepThree.description,
                object: stepReason.stepThree.object?.code ?? null,
                complaintUserProfilId: selectedSendTo.id,
                fokontanyId: stepReason.stepThree.fokontanyId,
                incidentDate: stepReason.stepThree.incidentDate,
                incidentLocation: stepReason.stepThree.location.code,
                natures: stepReason.stepFour.natureComplaintSelectedList.map(
                  (e) => e.id
                ),
                priority: "MEDIUM",
                receivedDate: new Date(),
                reportId: null,
                status: "PENDING",
                subNatures:
                  stepReason.stepFour.subNatureComplaintSelectedList.map(
                    (e) => e.id
                  ),
                complaintSubNatures: stepReason.stepFour.complaintSubNatures,
                userUuid: userInfos?.uuid?.value ?? "",
                resolutionLevel: "REGIONAL",
                rsuRelated:
                  stepReason.stepTwo.individualId.length > 0 &&
                  stepReason.stepTwo.householdId.length > 0,
                sensivity: "SENSITIVE",
                actionTaken: actionStepSeven,
              },
              onSuccess: () => {
                showSuccessMessage();
                setTimeout(() => {
                  setOpen(false);
                  navigate("/complaint/list-complaint");
                }, 2000);
              },
              onError: (error) => {
                if (error.response?.status === 409) {
                  const errorData = error.response?.data as
                    | { message?: string }
                    | undefined;
                  const data = error.response?.data as
                    | { data?: number }
                    | undefined;
                  setDialogObject({
                    open: true,
                    message: errorData?.message || "Conflit détecté",
                    code: data?.data || null,
                  });
                } else {
                  showErrorMessage(error);
                }
              },
            })
          );
        }
      } else {
        if (!mocipProfil) {
          // Sans ce profil la plainte partirait avec complaintUserProfilId vide, donc sans
          // affectation au Point Focal MOCIP : bloquer plutôt qu'enregistrer un cas orphelin.
          setMessageInfo({
            severity: "error",
            summary: "Erreur",
            detail:
              "Le profil « Point Focal MOCIP » est introuvable : impossible d'affecter la plainte.",
          });
          setOpen(true);
          return;
        }
        if (
          stepReason &&
          stepReason.stepOne &&
          stepReason.stepTwo &&
          stepReason.stepThree &&
          stepReason.stepFour &&
          stepReason.stepFive
        ) {
          dispatch(
            saveComplaint({
              filter: {
                aggressors: [],
                complaintDetails: [
                  {
                    ageGroup: null,
                    cin: stepReason.stepTwo.anonym
                      ? ""
                      : stepReason.stepTwo.cinNumber,
                    contactAddress: stepReason.stepTwo.address,
                    contactNumber: stepReason.stepTwo.anonym
                      ? ""
                      : stepReason.stepTwo.phoneNumber,
                    disability: stepReason.stepTwo.anonym
                      ? false
                      : stepReason.stepTwo.disabled,
                    fatherName: "",
                    motherName: "",
                    gender: null,
                    householdId: stepReason.stepTwo.householdId,
                    individualId: stepReason.stepTwo.individualId,
                    lastName: stepReason.stepTwo.anonym
                      ? ""
                      : transformName(stepReason.stepTwo.fullName)[0],
                    firstName: stepReason.stepTwo.anonym
                      ? ""
                      : transformName(stepReason.stepTwo.fullName)
                          .slice(1)
                          .join(" "),
                    martialStatus: null,
                    parentCohabitation: false,
                    disabilityInfo: null,
                    employee: null,
                    student: null,
                  },
                ],
                complaintInfo: {
                  fullName: stepReason.stepTwo.anonym
                    ? ""
                    : stepReason.stepTwo.fullName,
                  cinNumber: stepReason.stepTwo.anonym
                    ? ""
                    : stepReason.stepTwo.cinNumber,
                  phoneNumber: stepReason.stepTwo.anonym
                    ? ""
                    : stepReason.stepTwo.phoneNumber,
                  householdId: stepReason.stepTwo.householdId,
                  individualId: stepReason.stepTwo.individualId,
                  address: stepReason.stepTwo.anonym
                    ? ""
                    : stepReason.stepTwo.address,
                  disabled: stepReason.stepTwo.anonym
                    ? false
                    : stepReason.stepTwo.disabled,
                  anonym: stepReason.stepTwo.anonym,
                  isVictim: stepReason.stepTwo.isVictim,
                },
                description: stepReason.stepThree.description,
                object: stepReason.stepThree.object?.code ?? null,
                fokontanyId: stepReason.stepThree.fokontanyId,
                incidentDate: stepReason.stepThree.incidentDate,
                complaintUserProfilId: mocipProfil.id,
                careInstructions: [],
                supportTypes: [],
                resolutionLevel: "LOCAL",
                rsuRelated:
                  stepReason.stepTwo.individualId.length > 0 &&
                  stepReason.stepTwo.householdId.length > 0,
                sensivity: "SENSITIVE",
                incidentLocation: stepReason.stepThree.location.code,
                natures: stepReason.stepFour.natureComplaintSelectedList.map(
                  (e) => e.id
                ),
                priority: "LOW",
                receivedDate: new Date(),
                reportId: null,
                status: isSignature ? "PENDING" : selectedStatus.code,
                subNatures:
                  stepReason.stepFour.subNatureComplaintSelectedList.map(
                    (e: any) => e.id
                  ),
                userUuid: uuid ?? "",
                actionTaken: textAreaValue,
                complaintSubNatures: stepReason.stepFour.complaintSubNatures,
              },
              onSuccess: () => {
                showSuccessMessage();
                setTimeout(() => {
                  dispatch(setRecordValid(true));
                  setIsReadingAloud(false);
                  setOpen(false);

                  navigate("/complaint/list-complaint");
                }, 2000);
              },
              onError: (error) => {
                if (error.response?.status === 409) {
                  const errorData = error.response?.data as
                    | { message?: string }
                    | undefined;
                  const data = error.response?.data as
                    | { data?: number }
                    | undefined;
                  setDialogObject({
                    open: true,
                    message: errorData?.message || "Conflit détecté",
                    code: data?.data || null,
                  });
                } else {
                  showErrorMessage(error);
                }
              },
            })
          );
        }
      }
    };
    return (
      <>
        <Dialog
          visible={dialogObect.open}
          header={
            <div
              style={{ display: "flex", alignItems: "baseline", gap: "0.5rem" }}
            >
              <p className="text-xl">Information</p>
            </div>
          }
          className="w-[50vw] md:w-[30vw]"
          closable
          onHide={() =>
            setDialogObject({ open: false, message: "", code: null })
          }
        >
          <div className="flex items-center mb-4">
            <i className="pi pi-exclamation-triangle text-2xl mr-3" />
            <p className=" font-semibold">{dialogObect.message}</p>
          </div>

          <div className="w-full flex gap-3">
            <Button
              label="Non, annuler"
              className="btn btn-secondary w-full whitespace-nowrap"
              onClick={() => {
                setDialogObject({ open: false, message: "", code: null });
                setIsReadingAloud(false);
              }}
            />
            <Button
              label="Oui, rediriger"
              className="btn btn-primary w-full ml-3"
              onClick={() =>
                navigate(`/complaint/detail-complaint/${dialogObect.code}`)
              }
            />
          </div>
        </Dialog>

        <div className="w-full flex justify-between mt-4">
          <div className="w-full md:w-1/2">
            {(Record === "DEMARRE" ||
              (Record === "FINISHED" && readValid === false)) && (
              <Button
                className="btn bg-green-500 hover:!bg-green-900 w-[200px]"
                onClick={() => {
                  setRecord("IN_PROGRESS");
                  setTimer(0);
                  intervalRef.current = setInterval(() => {
                    setTimer((prev) => prev + 1);
                  }, 1000);
                }}
              >
                <p className="text-white flex items-center">
                  <i className="pi pi-microphone text-xl mr-1"></i>{" "}
                  {Record === "FINISHED" && readValid === false
                    ? "Refaire le contrôle"
                    : "Démarrer le contrôle"}
                </p>
              </Button>
            )}
            {Record === "IN_PROGRESS" && (
              <Button
                className="btn bg-orange-500 hover:!bg-orange-700 w-[200px]"
                onClick={() => {
                  setRecord("FINISHED");
                  if (intervalRef.current) {
                    clearInterval(intervalRef.current);
                    intervalRef.current = null;
                  }
                  let isValid;
                  if (isSignature) {
                    isValid = RecordAcceptable(
                      contenuText + contentSignatureText,
                      timer / 60
                    );
                  } else isValid = RecordAcceptable(contenuText, timer / 60);
                  setReadValid(isValid);
                }}
              >
                <p className="text-white flex items-center">
                  <i className="pi pi-microphone text-xl mr-1"></i>Contrôle en
                  cours
                </p>
              </Button>
            )}
          </div>
          <div className="w-full md:w-1/2 flex gap-3">
            {Record === "VALID" && readValid === true && (
              <>
                <Button
                  className="btn btn-secondary w-full whitespace-nowrap"
                  onClick={handleExportPDF}
                >
                  <i className="fas fa-upload mr-2"></i> Exporter en PDF
                </Button>
                <Button
                  label="Enregistrer"
                  className={classNames("btn btn-primary w-[150px]", {
                    "btn-primary-disabled": loading === FetchStatusType.LOADING,
                  })}
                  disabled={loading === FetchStatusType.LOADING}
                  onClick={handleSaveComplaint}
                />
              </>
            )}
          </div>
        </div>
      </>
    );
  };

  return (
    <>
      <ConfirmDialog
        visible={Record === "FINISHED" && readValid === true}
        message={messageConfirm}
        header="Confirmation"
        footer={
          <div className="flex justify-end gap-2">
            <Button
              label="Non valider"
              onClick={() => {
                setRecord("DEMARRE");
                setIsReadingAloud(false);
              }}
              className="p-button-text border px-3 py-1 bg-gray-400 text-white hover:bg-purple-950"
            />
            <Button
              label="Valider"
              autoFocus
              className="px-3 py-1 bg-purple-950 text-white"
              onClick={() => {
                setRecord("VALID");
                setReadValid(true);
              }}
            />
          </div>
        }
      />
      <Dialog
        visible={isReadingAloud}
        header={
          <>
            <div className="w-full flex justify-center">
              <img src={"/assets/LOGO_MPS.png"} alt="Logo" className="w-28" />
            </div>
            <div
              style={{ display: "flex", alignItems: "baseline", gap: "0.5rem" }}
            >
              <p className="stitle">Résumé de la plainte</p>
            </div>
          </>
        }
        className="w-[80vw] md:w-[50vw]"
        closable={
          !(
            (Record === "VALID" && readValid === true) ||
            Record === "IN_PROGRESS"
          )
        }
        onHide={() => setIsReadingAloud(false)}
        footer={footerContent}
      >
        <div>
          <div className="m-0 whitespace-pre-line text-gray-800 text-sm font-sans leading-6">
            {plaignantJSX}
            {contenuJSX}
            {isSignature ? contentSignatureJSX : ""}
          </div>
        </div>
      </Dialog>
    </>
  );
};

export default ReadingAloud;
